// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","1100":"(min-width: 1100px)","root":"hCSnt1kHlOA1Udk9Q3tC","multi":"z91bPXHttoNG04OAPN1q","bg":"Y5WvbePsC2b8IvfSorDf"};